import React from "react";
import MyProjects from "./Organization/Projects/MyProjects/MyProjects";
function ProjectsWrapper() {
    return (
        <MyProjects />
    )
}

export default ProjectsWrapper;